import {h, Component} from 'preact';
import linkState from 'linkstate';
import firebase from 'utils/firebase';

class Register extends Component {

	generatePassword = () => {
		return Array(6).fill("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz?!=()").map(function(x) { return x[Math.floor(Math.random() * x.length)] }).join('');
	}
	generateSecurePasswords = () => {
		this.generatedPassword = `${this.generatePassword()}-${this.generatePassword()}-${this.generatePassword()}-${this.generatePassword()}`;
		this.setState({
			password: this.generatedPassword,
			repassword: this.generatedPassword
		});
	}
	componentDidMount(){
		this.generateSecurePasswords()
	}
	validate = () => {
		const {name, email,reemail, password, repassword} = this.state;

		if(!name || name.trim().length < 3 || name.trim().indexOf(' ') === -1) {
			this.setState({error: 'name'});
			return false;
		}

		if(!email || !email.split('@')[1] || email.split('@')[1].indexOf('.') === -1 || !email.split('@')[1].split('.')[1] ) {
			this.setState({error: 'email'});
			return false;
		}
		if(!reemail ||reemail !== email) {
			this.setState({error: 'reemail'});
			return false;
		}
		if(!password || password.length < 6) {
			this.setState({error: 'password'});
			return false;
		}
		if(!repassword ||repassword !== password) {
			this.setState({error: 'repassword'});
			return false;
		}
		return true;
	}
	submit = (e) => {
		e.preventDefault();
		e.stopImmediatePropagation();
		this.setState({ loading: true });

		const {name, email, password, repassword, terms} = this.state;

		if(this.validate()) {
			this.setState({loading: true});
			firebase.auth()
				.createUserWithEmailAndPassword(email, password)
				.catch((error) => {
					// Handle Errors here.
					this.setState({loading: false, error });
					console.error(error);
				});
		} else {
			this.setState({ loading: false });
		}
	}
	componentWillUnmount(){
		const user = firebase.auth().currentUser;
		const {name} = this.state;

		console.log({user, name})
		if(user && name) {
			this.context.updateProfile({
				displayName: this.state.name.trim()
			});
		}
	}

	render(props,state) {
		return <div>
					<div class="modal-backdrop fade show" />
					<div class="modal fade show" id="contact-box-modal" tabindex="-1" role="dialog" aria-modal="true" style="display: block;">
						<div class="modal-dialog modal-dialog-centered" role="document">
							<div class="modal-content">
								<div class="modal-body">
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={props.onClose}>
										<svg class="icon bg-dark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M16.2426 6.34311L6.34309 16.2426C5.95257 16.6331 5.95257 17.2663 6.34309 17.6568C6.73362 18.0473 7.36678 18.0473 7.75731 17.6568L17.6568 7.75732C18.0473 7.36679 18.0473 6.73363 17.6568 6.34311C17.2663 5.95258 16.6331 5.95258 16.2426 6.34311Z" fill="#212529"></path>
											<path d="M17.6568 16.2426L7.75734 6.34309C7.36681 5.95257 6.73365 5.95257 6.34313 6.34309C5.9526 6.73362 5.9526 7.36678 6.34313 7.75731L16.2426 17.6568C16.6331 18.0473 17.2663 18.0473 17.6568 17.6568C18.0474 17.2663 18.0474 16.6331 17.6568 16.2426Z" fill="#212529"></path>
										</svg>
									</button>
									<div class="m-3">
										<h5>Luo tili</h5>
										<div class="row text-left">
											<div class="col-auto">
						                      <p class="text-small text-600">Onko sinulla jo tunnus? <a href="#" onClick={e => {e.preventDefault();e.stopImmediatePropagation(); props.onLogin()}}>Kirjaudu sisään</a></p>
						                    </div>
						                </div>
										{state.error && typeof state.error !== 'string' ? <div class="alert alert-primary" role="alert">
											Tiliä ei voida luoda, tarkistathan tietosi. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.
											 <br /><br />
											 Virheviesti: "<em>{state.error.message}</em>"
										 </div> : null}
										<form class="needs-validation" novalidate="" onSubmit={this.submit}>
											<div class="row">
												<div class="col-md-12 mb-3">
													<input type="text" class="form-control" id="name" placeholder="" autocomplete="name" onInput={linkState(this,'name')} value={state.name} required="" placeholder="Koko nimi"/>
													<div class="invalid-feedback" style={state.error === 'name' ? 'display:block;' : null}>
														Tarkista, että syötit etunimen ja sukunimen.
													</div>
												</div>

												<div class="col-6 mb-3">
													<input type="email" class="form-control" autocomplete="email" id="email" placeholder="" onInput={linkState(this,'email')} value={state.email} required="" placeholder="Sähköpostiosoite"/>
													<div class="invalid-feedback" style={state.error === 'email' ? 'display:block;' : null}>
														Sähköpostiosoite on pakollinen kenttä.
													</div>
												</div>

												<div class="col-6 mb-3">
													<input type="email" class="form-control" id="reemail" placeholder="" onInput={linkState(this,'reemail')} value={state.reemail} required="" placeholder="Vahvista sähköpostiosoite"/>
													<div class="invalid-feedback" style={state.error === 'reemail' ? 'display:block;' : null}>
														Sähköpostiosoitteet eivät täsmää.
													</div>
												</div>
											</div>
											<hr class="mt-0"/>
											<div class="row mb-2">
												<div class="col-md-6 mb-3">
													<input type={state.password === this.generatedPassword ? "text" : "password"} autocomplete="new-password" class="form-control" id="password" placeholder="" onInput={linkState(this,'password')} value={state.password} required=""  placeholder="Salasana"/>
													<div class="invalid-feedback" style={state.error === 'password' ? 'display:block;' : null}>
														Salasana on pakollinen kenttä. Salasanan tulee olla vähintään 6 merkkiä.
													</div>
												</div>
												<div class="col-md-6 mb-3">
													<input type={state.password === this.generatedPassword ? "text" : "password"} autocomplete="new-password" class="form-control" id="repassword" placeholder="" onInput={linkState(this,'repassword')} value={state.repassword} required="" placeholder="Vahvista salasana"/>
													<div class="invalid-feedback" style={state.error === 'repassword' ? 'display:block;' : null}>
														Salasanat eivät täsmää.
													</div>
												</div>
											</div>
											{false ?
											<div>
												<hr class="mb-2" />
												<div class="row mb-3">
													<div class="col-12 mb-2">
														<div class="custom-control custom-switch">
															<input type="checkbox" class="custom-control-input" id="marketingPermission" onClick={linkState(this,'marketingPermission')} checked={state.marketingPermission} />
															<label class="custom-control-label" for="marketingPermission">Haluan saada sähköpostiini tiedon uusista mielenkiintoisista tapahtumista</label>
														</div>
													</div>
												</div>
											</div> : null}
											{state.loading ?
											<button class="btn btn-primary-3 btn-block btn-loading btn-loading-animate" disabled>
												<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="injected-svg icon" data-src="assets/img/icons/theme/code/loading.svg">
													<title>Icon For Loading</title>
													<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<g>
															<polygon points="0 0 24 0 24 24 0 24" opacity="0"></polygon>
														</g>
														<path d="M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z" fill="#000000" fill-rule="nonzero" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, 12.000000)"></path>
													</g>
												</svg>
												<span>Luodaan tiliä</span>
											</button>
											:
											<button class="btn btn-primary-3 btn-block" type="submit" onClick={this.submit}>Luo tili</button>
											}
											<div class="mt-2">
												<p class="text-muted form-text">Luomalla tilin olet lukenut Lippumaatin <a href="/tietosuojalauseke" target="_blank">tietosuojalausekkeen</a> ja hyväksyt <a href="/kayttoehdot" target="_blank">käyttöehdot</a></p>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
	}
}

export default Register



// WEBPACK FOOTER //
// ./components/register/index.js